import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";

const HoroscopoGallo = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Gallo - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Gallo. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Gallo." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="text-7xl mb-4">🐓</div>
              <h1 className="text-3xl font-bold mb-2">Gallo</h1>
              <p className="text-muted-foreground">Años: 1933, 1945, 1957, 1969, 1981, 1993, 2005, 2017, 2029</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu honestidad y lealtad brillan especialmente hoy, Gallo. Tu sinceridad directa crea confianza en las relaciones. Las parejas apreciarán tu franqueza y compromiso genuino.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu atención al detalle y perfeccionismo te llevarán al éxito hoy. Tu organización impecable y habilidad para planificar serán reconocidas. Es momento de mostrar tu excelencia.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu disciplina natural favorece buenos hábitos de salud. Mantén tu rutina estructurada pero permite flexibilidad. El ejercicio matutino te energizará para todo el día.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será ideal para conversaciones honestas sobre el futuro. Tu claridad y confianza fortalecerán los lazos con tu pareja. Los solteros atraerán personas que valoran la autenticidad.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu dedicación y trabajo meticuloso darán frutos visibles. Proyectos que requieren precisión y estándares altos prosperarán bajo tu supervisión. Tu ética laboral será admirada.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía estará óptima. Aprovecha para optimizar tus rutinas de salud. Tu naturaleza organizada te ayudará a mantener hábitos consistentes y efectivos.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de claridad y compromiso en las relaciones. Tu honestidad construirá bases sólidas para el futuro. Las parejas disfrutarán de la estabilidad que tu lealtad proporciona.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu perfeccionismo será tu mayor ventaja. Proyectos importantes se completarán con excelencia bajo tu dirección. Tu reputación de confiabilidad se fortalecerá.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén tu rutina de salud estructurada esta semana. Tu disciplina natural asegurará resultados consistentes. No olvides incluir tiempo para relajarte y desconectar.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoGallo;
